var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-congress",on:{"click":_vm.toLink}},[_c('img',{attrs:{"src":"https://qiniu.laway.cn/yn/2023/04/28/a1905800e5aa11ed9d4db4055d0b07be.png","width":"350","alt":""}}),_c('h2',[_vm._v("云南省人大常委会基层立法联系点")]),_c('h2',[_vm._v("昆明市人大常委会基层立法联系点")]),_c('p',[_vm._v(" 立法建议网上征集平台（请点击屏幕进入） ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }